module.exports = {
      id: "ic-area-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-area-usage",
      toString: function () {
        return this.url;
      }
    }